module.exports = __webpack_public_path__ + "static/media/portfolio-img1.4c19ed58.JPG";